import { createRoleGuard } from './create-role-guard'

export const supportGuard = createRoleGuard((role) => role === 'SUPPORT')
